import React from 'react';
import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import HeadMetaTag from '@/components/metatags/HeadMetaTag';
import CrieSeuRoteiro from '@/features/forms/CrieSeuRoteiro/CrieSeuRoteiro';
import { fetchWebAPINavigation, fetchWebAPIServerDataHandler } from '@/lib/fetcher';
import { CrieSeuRoteiroProvider } from '@/features/forms/CrieSeuRoteiro/context';
import CustomError from '@/features/errors';
import AppProvider from '@/context/AppProvider';
import fetchMessages from '@/fetchMessages';

export const getServerSideProps: GetServerSideProps = async ({ req, ...rest }) => {
  const { messages, locale } = await fetchMessages(rest.locale as string);

  const qs = locale ? `?locale=${locale}` : '';
  const path = `/forms/crie-seu-roteiro${qs}`;

  const [navigation, pageProps] = await Promise.all([
    fetchWebAPINavigation({ locale }),
    fetchWebAPIServerDataHandler(path, 'VIAGENS CRIE-SEU-ROTEIRO', req),
  ]);

  const { props, notFound, redirect } = pageProps;
  if (notFound !== undefined) return { notFound: true };
  if (redirect !== undefined) return { redirect };
  if (props !== undefined) return { props: { ...props, navigation, messages } };
  return {
    props: {
      data: null,
    },
  };
};

const Page = ({ error, data, ...props }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  if (error) {
    return <CustomError error={error} />;
  }

  const { meta } = data.page;
  return (
    <AppProvider navigation={props.navigation}>
      <HeadMetaTag meta={meta} />
      <CrieSeuRoteiroProvider data={data}>
        <CrieSeuRoteiro />
      </CrieSeuRoteiroProvider>
    </AppProvider>
  );
};

export default Page;
